import { atom } from 'jotai';

export const routeParamsState = atom<{ companyId?: string }>({});
